module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "modal",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "info-title"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/images/website/zappelin-logo.png'),
      "alt": "Zappelin logo"
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "info-title"
    }
  }, [_vm._v("De Boterhamshow informatie")])]), _vm._v(" "), _c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Sluiten"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "aria-hidden": "true",
      "height": "24px",
      "id": "Layer_1",
      "version": "1.1",
      "viewBox": "0 0 512 512",
      "width": "24px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "info-text"
  }, [_vm._v("Welkom op de site van de Boterhamshow! Sinds 2023 worden er helaas geen nieuwe afleveringen meer gemaakt en wordt ook deze site niet meer actief geüpdatet. Het kan daarom zijn dat sommige onderdelen in de loop der tijd niet meer (helemaal) naar behoren werken. Omdat het een archief-site betreft voldoet deze helaas niet aan alle huidige eisen wat betreft WCAG en toegankelijkheid. Onze excuses daarvoor.")]), _vm._v(" "), _c('p', {
    staticClass: "info-text"
  }, [_vm._v("Veel plezier op de site! De afleveringen van de Boterhamshow zijn nog steeds beschikbaar om te "), _c('a', {
    staticClass: "info-text__link",
    attrs: {
      "href": "https://npo.nl/start/serie/de-boterhamshow/afleveringen",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("bekijken op NPO Start"), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(" (opent in nieuw tabblad)")])]), _vm._v(" en de podcast is hier op deze site te beluisteren.")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08ed614d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoModal.vue
// module id = 701
// module chunks = 64